import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useData } from 'hooks/useData';
import clsx from 'clsx';
import Imatge from 'components/3catinfo/Imatge';
import Boto from 'components/3catinfo/Boto';
import Titol from 'components/3catinfo/Titol';
import styles from './mapesanimats.module.scss';

const MapesAnimats = (props) => {
    const { titol, items, mostrarBotonsVista = false, estil, tipusMapa, autoPlay = false, speed = 200, urlBase } = props;
    const router = useRouter();
    const { data: itemsMap, getDades: getItems } = useData();
    const [loading, setLoading] = useState(false);
    const [itemsMapa, setItemsMapa] = useState(items);
    const [play, setPlay] = useState(autoPlay);
    const [zoom, setZoom] = useState(true);
    const [view, setView] = useState(mostrarBotonsVista ? 'vis' : 'basic');
    const [current, setCurrent] = useState(0);
    const pathImag = 'https://statics.3cat.cat/meteo';

    useEffect(() => {
        setItemsMapa(items);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.asPath]);

    useEffect(() => {
        if (play) {
            const timer = setInterval(() => {
                setCurrent((prevIndex) => (prevIndex + 1) % itemsMapa.length);
            }, speed);
            return () => clearInterval(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [play, itemsMapa]);

    useEffect(() => {
        if (itemsMap?.items?.Mapa) {
            setItemsMapa(itemsMap?.items?.Mapa);
            setCurrent(0);
            setTimeout(() => {
                setLoading(false);
            }, 300);
        }
    }, [itemsMap]);

    const getItemsMapa = (tipus, zoomActiu, urlBase) => {
        setLoading(true);
        const configUrls = {
            vis: zoomActiu
                ? '&fitxer=satelit/visible&version=2.0&cache=180&https=true&master=yes&perfils_extra=imatges_3catinfo'
                : '-granescala&fitxer=satelit/visible&version=2.0&cache=180&https=true&master=yes&perfils_extra=imatges_3catinfo',
            ir: zoomActiu
                ? '&fitxer=satelit/boiranit&version=2.0&cache=180&https=true&master=yes&perfils_extra=imatges_3catinfo'
                : '-granescala&fitxer=satelit/boiranit&version=2.0&cache=180&https=true&master=yes&perfils_extra=imatges_3catinfo',
            basic: zoomActiu
                ? '&fitxer=' + tipusMapa + '&version=2.0&cache=180&https=true&master=yes&perfils_extra=imatges_3catinfo'
                : '-granescala&fitxer=' +
                  tipusMapa +
                  '&version=2.0&cache=180&https=true&master=yes&perfils_extra=imatges_3catinfo'
        };
        const url = urlBase + configUrls[tipus];
        getItems(url);
    };

    const stylesMapa = clsx({
        [styles.mapaContainer]: true,
        [styles[estil]]: !!estil
    });

    return (
        <div className={stylesMapa} data-testid='mapes-animats'>
            {mostrarBotonsVista && (
                <div className={styles.capcalera}>
                    <Titol tag='h2' titol={titol} className={styles.titol} />
                    <div className={styles.submenus}>
                        <Boto
                            tag='button'
                            className={view === 'ir' ? styles.viewActiu : styles.viewInactiu}
                            tema='gris'
                            text='IR'
                            onClick={() => {
                                setView('ir');
                                getItemsMapa('ir', zoom, urlBase);
                            }}
                        />
                        <Boto
                            tag='button'
                            className={view === 'vis' ? styles.viewActiu : styles.viewInactiu}
                            tema='gris'
                            text='VIS'
                            onClick={() => {
                                setView('vis');
                                getItemsMapa('vis', zoom, urlBase);
                            }}
                        />
                    </div>
                </div>
            )}
            <div className={styles.content}>
                <div className={styles.imatge}>
                    {itemsMapa?.map((item, index) => (
                        <div
                            className={index === current && !loading ? styles.showFrame : styles.hiddenFrame}
                            key={`imatge-mapa-${index}`}
                        >
                            <Imatge
                                src={pathImag + item?.attributes?.img}
                                tipus='web_destacat'
                                alt={titol}
                                aria-hidden='true'
                                layout='fill'
                                objectFit='cover'
                                crop='1903'
                                data_testid='destacat-img'
                            />
                        </div>
                    ))}
                    {loading && (
                        <div className={styles.loading}>
                            <div className={styles.spinnerLoading}>
                                <Imatge
                                    src='/_resources/imatges/3catinfo/loading-spin.png'
                                    layout='fill'
                                    mostrarRecursTitol={false}
                                    objectFit='cover'
                                    alt=''
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles.controls}>
                    <div className={styles.controlsPlay}>
                        <Boto
                            tag='button'
                            icona='fletxa_simple_esquerra'
                            className={`${styles.botoControl} ${styles.botoPrev}`}
                            estil='transparent'
                            isIconaBlanc={true}
                            onClick={() => setCurrent((prevIndex) => (prevIndex - 1 + items.length) % items.length)}
                            mida={52}
                        />
                        {!play && (
                            <Boto
                                tag='button'
                                icona='play'
                                className={styles.botoControl}
                                estil='transparent'
                                isIconaBlanc={true}
                                onClick={() => setPlay(true)}
                                mida={24}
                            />
                        )}
                        {play && (
                            <Boto
                                tag='button'
                                icona='pause_ple'
                                className={styles.botoControl}
                                estil='transparent'
                                isIconaBlanc={true}
                                onClick={() => setPlay(false)}
                                mida={24}
                            />
                        )}
                        <Boto
                            tag='button'
                            icona='fletxa_simple_dreta'
                            className={`${styles.botoControl} ${styles.botoNext}`}
                            estil='transparent'
                            isIconaBlanc={true}
                            onClick={() => setCurrent((prevIndex) => (prevIndex + 1) % items.length)}
                            mida={52}
                        />
                    </div>
                    <div className={styles.datetime}>
                        {!loading && itemsMapa?.[current]?.attributes?.data + ' - ' + items?.[current]?.attributes?.hora + ' UTC'}
                    </div>
                    <div className={styles.zoomControls}>
                        <div className={zoom ? styles.zoomInactiu : styles.zoomActiu}>
                            <Boto
                                tag='button'
                                icona='lupa-out'
                                className={styles.botoControl}
                                estil='transparent'
                                isIconaBlanc={zoom}
                                onClick={() => {
                                    setZoom(false);
                                    getItemsMapa(view, false, urlBase);
                                }}
                            />
                        </div>
                        <div className={zoom ? styles.zoomActiu : styles.zoomInactiu}>
                            <Boto
                                tag='button'
                                icona='lupa-in'
                                className={styles.botoControl}
                                estil='transparent'
                                isIconaBlanc={!zoom}
                                onClick={() => {
                                    setZoom(true);
                                    getItemsMapa(view, true, urlBase);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MapesAnimats;
